module.exports = __webpack_public_path__ + "media/public/img/viator-review-widget-01-363d65f17b203e82e80c83508294f9cc.svg";